import { useStore } from '@tanstack/react-form';
import { useCallback, useMemo } from 'react';

import { deepAssignKeyValue, getTestProps } from '../../../../lib/helpers';

import VariantCard from '../../../../components/VariantCard/VariantCard';

import { useFieldContext, useFormContext } from '../../../form';

const VariantField = ({
  media,
  openVariantModal,
  deleteVariant,
  idx,
  disabled,
  testId,
}) => {
  const form = useFormContext();
  const field = useFieldContext();

  const errors = useStore(form.store, ({ fieldMeta }) => {
    const variantErrors = {};
    Object.entries(fieldMeta)
      ?.filter(
        ([key, { errors }]) => key.startsWith(field.name) && errors.length,
      )
      .forEach(([key, { errors }]) => {
        deepAssignKeyValue(key, errors, variantErrors);
      });
    return variantErrors.variants?.[idx];
  });

  const variant = useMemo(() => field.state.value, [field.state.value]);

  const isNew = useMemo(
    () =>
      !(form.options?.defaultValues?.variants || []).find(
        (oldVariant) => oldVariant.name === variant.name,
      ),
    [form.options?.defaultValues?.variants, variant.name],
  );

  const onDelete = useCallback(() => deleteVariant(idx), [deleteVariant, idx]);

  const onEdit = useCallback(() => {
    openVariantModal(variant, idx, errors);
  }, [openVariantModal, variant, idx, errors]);

  return (
    <VariantCard
      variant={field.state.value}
      media={media}
      onEdit={isNew ? onEdit : null}
      onDelete={onDelete}
      errors={errors}
      isNew={isNew}
      disabled={disabled}
      {...getTestProps(testId, variant.name, 'testId')}
    />
  );
};

export default VariantField;
